import { Button } from "antd";
import React from "react";

const ButtonBar = ({
  leadEnable,
  downloadVcfFile,
  setShowExchangeCard,
  sColor,
}) => {
  return (
    <>
      <Button
        style={{
          height: "2.5rem",
          minWidth: !leadEnable ? "50%" : 0,
          borderColor: sColor,
          color: sColor,
          margin: "1rem",
          borderWidth: 0,
          boxShadow: "3px 3px 3px 3px #88888a3a",
        }}
        shape="round"
        size="middle"
        onClick={downloadVcfFile}
      >
        Save My Contact
      </Button>
      {leadEnable && (
        <Button
          style={{
            height: "2.5rem",
            borderColor: sColor,
            color: sColor,
            margin: "1rem",
            borderWidth: 0,
            boxShadow: "3px 3px 3px 3px #88888a3a",
          }}
          shape="round"
          size="middle"
          onClick={() => {
            setShowExchangeCard((prev) => !prev);
          }}
        >
          Exchange Contact
        </Button>
      )}
    </>
  );
};
export default ButtonBar;
